var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useCallback } from 'react';
import { useCurrentAccount } from '@mysten/dapp-kit-react';
import { useSignAndExecuteTransaction } from '../hooks/walletCompat';
import { CetusCompensationPage as CetusCompensationPageAlphafi, commaFy, NotificationComp, } from 'ui-kit';
import { getImage } from '../utils/getImage';
import { getIcon } from '../utils/getIcon';
import { getUserCompensationAmountAll, userCollectCetusCompensation, userCollectCetusCompensationAll, } from 'alphafi-sdk-js';
// Transaction URL (for future use)
// const transactionUrl = 'https://suivision.xyz/txblock';
const CetusCompensationPage = ({ themeName }) => {
    const currentAccount = useCurrentAccount();
    const [cetusCompensationData, setCetusCompensationData] = useState({});
    const signAndExecuteTransaction = useSignAndExecuteTransaction();
    const [singleCetusCompensationClaimButtonLoading, setSingleCetusCompensationClaimButtonLoading] = useState(false);
    const [totalCetusTokens, setTotalCetusTokens] = useState(0);
    const [allCetusCompensationClaimButtonLoading, setAllCetusCompensationClaimButtonLoading] = useState(false);
    const [loadingPoolName, setLoadingPoolName] = useState('');
    const [isLoadingData, setIsLoadingData] = useState(true);
    const [notificationInfo, setNotificationInfo] = useState({
        title: '',
        description: '',
    });
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);
    const fetchCetusCompensation = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setIsLoadingData(true);
            if (currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.address) {
                const cetusCompensation = yield getUserCompensationAmountAll(currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.address);
                setCetusCompensationData(cetusCompensation[0]);
                setTotalCetusTokens(cetusCompensation[1]);
            }
        }
        catch (error) {
            console.error(error);
        }
        finally {
            setIsLoadingData(false);
        }
    }), [currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.address]);
    useEffect(() => {
        fetchCetusCompensation();
    }, [currentAccount, fetchCetusCompensation]);
    const claimSingleCetusCompensation = (poolName, amount) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (currentAccount) {
                setLoadingPoolName(poolName);
                setSingleCetusCompensationClaimButtonLoading(true);
                const transactionBlock = yield userCollectCetusCompensation(poolName, currentAccount.address);
                if (!transactionBlock) {
                    setSingleCetusCompensationClaimButtonLoading(false);
                    setLoadingPoolName('');
                    return;
                }
                transactionBlock === null || transactionBlock === void 0 ? void 0 : transactionBlock.setGasBudget(300000000);
                setNotificationInfo({
                    title: 'Processing Transaction',
                    description: `Processing transaction to claim ${parseFloat(amount.toString()).toFixed(4)} CETUS from ${poolName} pool`,
                    spinner: true,
                    image: null,
                });
                setIsNotificationOpen(true);
                signAndExecuteTransaction({
                    transaction: transactionBlock,
                }, {
                    onSuccess: (result) => __awaiter(void 0, void 0, void 0, function* () {
                        if (result.success) {
                            console.log(`Successfully claimed ${parseFloat(amount.toString()).toFixed(4)} CETUS from ${poolName} pool`);
                            fetchCetusCompensation();
                            setNotificationInfo({
                                title: 'Transaction Successful',
                                description: `You have successfully claimed ${parseFloat(amount.toString()).toFixed(4)} CETUS from ${poolName} pool`,
                                spinner: false,
                                image: getIcon('success'),
                            });
                            setIsNotificationOpen(true);
                        }
                        else {
                            console.error(`Failed to claim CETUS from ${poolName} pool`);
                        }
                        setSingleCetusCompensationClaimButtonLoading(false);
                        setLoadingPoolName('');
                    }),
                    onError(error, variables, context) {
                        console.error('Transaction error:', error, variables, context);
                        setSingleCetusCompensationClaimButtonLoading(false);
                        setLoadingPoolName('');
                        setNotificationInfo({
                            title: 'Transaction Failed',
                            description: `You have rejected the transaction to claim ${parseFloat(amount.toString()).toFixed(4)} CETUS from ${poolName} pool`,
                            link: ``,
                            image: getIcon('failed'),
                            spinner: false,
                        });
                        setIsNotificationOpen(true);
                    },
                });
            }
        }
        catch (error) {
            console.error(error);
            setSingleCetusCompensationClaimButtonLoading(false);
            setLoadingPoolName('');
        }
    });
    const claimAllCetusCompensation = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (currentAccount) {
                setAllCetusCompensationClaimButtonLoading(true);
                const transactionBlock = yield userCollectCetusCompensationAll(currentAccount.address);
                if (!transactionBlock) {
                    setAllCetusCompensationClaimButtonLoading(false);
                    return;
                }
                transactionBlock === null || transactionBlock === void 0 ? void 0 : transactionBlock.setGasBudget(300000000);
                setNotificationInfo({
                    title: 'Processing Transaction',
                    description: `Processing transaction to claim ${commaFy(parseFloat((totalCetusTokens / Math.pow(10, 9)).toString()).toFixed(4))} CETUS tokens`,
                    spinner: true,
                    image: null,
                });
                setIsNotificationOpen(true);
                signAndExecuteTransaction({
                    transaction: transactionBlock,
                }, {
                    onSuccess: (result) => __awaiter(void 0, void 0, void 0, function* () {
                        if (result.success) {
                            console.log(`Successfully claimed ${commaFy(parseFloat((totalCetusTokens / Math.pow(10, 9)).toString()).toFixed(4))} CETUS tokens`);
                            fetchCetusCompensation();
                            setNotificationInfo({
                                title: 'Transaction Successful',
                                description: `You have successfully claimed ${commaFy(parseFloat((totalCetusTokens / Math.pow(10, 9)).toString()).toFixed(4))} CETUS tokens`,
                                spinner: false,
                                image: getIcon('success'),
                            });
                            setIsNotificationOpen(true);
                        }
                        else {
                            console.error('Failed to claim all CETUS compensation');
                            setNotificationInfo({
                                title: 'Transaction Failed',
                                description: `You have rejected the transaction to claim ${commaFy(parseFloat((totalCetusTokens / Math.pow(10, 9)).toString()).toFixed(4))} CETUS tokens`,
                                link: ``,
                                image: getIcon('failed'),
                                spinner: false,
                            });
                            setIsNotificationOpen(true);
                        }
                        setAllCetusCompensationClaimButtonLoading(false);
                    }),
                    onError(error, variables, context) {
                        console.error('Transaction error:', error, variables, context);
                        setNotificationInfo({
                            title: 'Transaction Failed',
                            description: `You have rejected the transaction to claim ${commaFy(parseFloat((totalCetusTokens / Math.pow(10, 9)).toString()).toFixed(4))} CETUS tokens`,
                            link: ``,
                            image: getIcon('failed'),
                            spinner: false,
                        });
                        setIsNotificationOpen(true);
                        setAllCetusCompensationClaimButtonLoading(false);
                    },
                });
            }
        }
        catch (error) {
            console.error(error);
            setAllCetusCompensationClaimButtonLoading(false);
        }
    });
    // Calculate current total CETUS tokens (converted from raw amount)
    const currentTotalCetusTokens = parseFloat((totalCetusTokens / Math.pow(10, 9)).toFixed(4));
    return (_jsxs("div", { className: "theme-bg-alphafi-primary h-screen overflow-y-auto", children: [_jsx(CetusCompensationPageAlphafi, { title: "Cetus Compensation", subtitle: "As compensation is released, it will be updated here.", statsCardData: {
                    stats: [
                        {
                            value: commaFy(currentTotalCetusTokens.toString()),
                            label: 'Total CETUS',
                            collectButton: currentTotalCetusTokens > 0,
                            handleCollectButtonClick: currentTotalCetusTokens > 0 ? claimAllCetusCompensation : undefined,
                            // buttonLoading: allCetusCompensationClaimButtonLoading, // Property doesn't exist in UI kit
                        },
                    ],
                }, compensationCards: Object.entries(cetusCompensationData)
                    .filter(([, data]) => (data === null || data === void 0 ? void 0 : data.receiptId) && (data === null || data === void 0 ? void 0 : data.receiptId) !== '' && (data === null || data === void 0 ? void 0 : data.amount) > 0)
                    .map(([poolName, data]) => {
                    const [token1, token2] = poolName.split('-');
                    const formattedAmount = parseFloat((data.amount / Math.pow(10, 9)).toFixed(4));
                    console.log('token1', token1.toLowerCase(), 'token2', token2.toLowerCase());
                    return {
                        tokens: [
                            { symbol: token1, image: getIcon(token1.toLowerCase()) },
                            { symbol: token2, image: getIcon(token2.toLowerCase()) },
                        ],
                        amount: commaFy(formattedAmount.toString()),
                        amountSymbol: 'CETUS',
                        availableText: 'Available to Claim',
                        buttonText: 'Claim',
                        onClaim: () => claimSingleCetusCompensation(poolName, formattedAmount),
                        isLoading: singleCetusCompensationClaimButtonLoading && loadingPoolName === poolName,
                        isDisabled: singleCetusCompensationClaimButtonLoading || allCetusCompensationClaimButtonLoading,
                    };
                }), noDataImage: themeName === 'dark' ? getImage('noDataDark') : getImage('noDataLight'), noDataImageText: "No Compensation Data Available", isLoading: isLoadingData }), _jsx(NotificationComp, { isOpen: isNotificationOpen, setIsOpen: setIsNotificationOpen, info: notificationInfo })] }));
};
export default CetusCompensationPage;
